export const computeVirtualRowsFromSelectionMode = (
  selectedVirtualRows: number,
  datasetData: any,
  data: any[] | undefined,
  selectionMode: string | undefined
) => {
  switch (selectionMode) {
    case 'dontcare':
      return 0;
    case 'dontcare_useall':
      //all in filter
      return datasetData?.totalCount
        ? datasetData.totalCount - (data?.length ?? 0)
        : 0;
    case 'any':
      return selectedVirtualRows;
    case 'justone':
      return 0;
    case 'oneormore':
      return selectedVirtualRows;
    default:
      return 0;
  }
};
